import { putUser, useUser } from "../../../fetch/fetch.user";
import { EMPTY_USER_PROFILE } from "../../../const/typeDefault/User";
import { IconError404, IconHeart } from "@tabler/icons-react";
import LoadingButton from "../../core/loading/LoadingButton";
import { useSWRConfig } from "swr";
import { USER_URL } from "../../../fetch/const.routes";
import { ReactNode, useContext } from "react";
import { SubmitContext } from "../../../context/context.submit";

const ItemBookmarkController = ({
  itemId,
  userId,
  children,
}: {
  itemId: string;
  userId: string;
  children: (
    handleBookmark: () => void,
    loading: boolean,
    error?: string,
    isBookmarked?: boolean,
  ) => ReactNode;
}) => {
  const { initSubmit, finishSubmit, loading, error } =
    useContext(SubmitContext);
  const { user, isLoading, isError } = useUser(userId, EMPTY_USER_PROFILE);
  const { mutate } = useSWRConfig();
  if (isError) return <IconError404 />;
  if (isLoading)
    return (
      <LoadingButton className={"btn btn-square"}>
        <IconHeart />
      </LoadingButton>
    );
  const handleBookmark = async () => {
    if (!initSubmit()) return;
    const set = new Set<string>(user.bookmarkedItems);
    const included = set.delete(itemId);
    if (!included) {
      set.add(itemId);
    }
    const payload = Array.from(set);
    await mutate(
      USER_URL + userId,
      { ...user, bookmarkedItems: payload },
      false,
    );
    await putUser({ bookmarkedItems: payload });
    finishSubmit(false);
  };
  const isBookmarked = user.bookmarkedItems?.includes(itemId);
  if (error) console.error(error);
  return children(handleBookmark, loading, error, isBookmarked);
};
export default ItemBookmarkController;
